import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowTopRightOnSquareIcon, EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/outline';
import './Footer.css';

const exploreLinks = [
  { label: 'Training programs', to: '/courses' },
  { label: 'Career guidance', to: '/career' },
  { label: 'Opportunities', to: '/opportunities' },
  { label: 'About GMSP3', to: '/about' },
  { label: 'Applications help', to: '/help/applications' },
  { label: 'Help centre', to: '/help' }
];

// General Gauteng contact channels verified on 15 October 2026 against
// https://www.gauteng.gov.za/Pages/index.aspx.
// Programme-specific learner guidance is available through the app's Help centre.
const Footer = () => (
  <footer className="site-footer" aria-label="Site information">
    <div className="site-footer-container">
      <div className="site-footer-main">
        <div className="site-footer-brand">
          <Link to="/" className="site-footer-brand-link" aria-label="GMSP3 Career Guidance home">
            <img src="/images/GPG_LOGO.png" alt="" width="44" height="48" loading="lazy" />
            <span><strong>GMSP3</strong><span>Career Guidance</span></span>
          </Link>
          <p>Gauteng City Region Academy (GCRA)</p>
        </div>

        <nav className="site-footer-navigation" aria-labelledby="site-footer-explore">
          <h2 id="site-footer-explore">Explore</h2>
          <ul>{exploreLinks.map(link => <li key={link.to}><Link to={link.to}>{link.label}</Link></li>)}</ul>
        </nav>

        <div className="site-footer-contact">
          <h2>General enquiries</h2>
          <p>Gauteng Provincial Government hotline</p>
          <address>
            <a href="tel:0800228827"><PhoneIcon aria-hidden="true" /><span>0800 228 827</span></a>
            <a href="mailto:hotline@gauteng.gov.za"><EnvelopeIcon aria-hidden="true" /><span>hotline@<wbr />gauteng.gov.za</span></a>
          </address>
          <a href="https://www.gauteng.gov.za/" className="site-footer-government" target="_blank" rel="noopener noreferrer">
            Government website<ArrowTopRightOnSquareIcon aria-hidden="true" /><span className="site-footer-sr-only"> (opens in a new tab)</span>
          </a>
        </div>
      </div>

      <div className="site-footer-bottom">
        <p>© {new Date().getFullYear()} Gauteng Provincial Government</p>
        <nav aria-label="Legal information">
          <Link to="/privacy">Privacy policy</Link>
          <Link to="/terms">Terms of service</Link>
        </nav>
      </div>
    </div>
  </footer>
);

export default Footer;
